import { render, staticRenderFns } from "./integral-report.vue?vue&type=template&id=ca0f91de&scoped=true&"
import script from "./integral-report.vue?vue&type=script&lang=js&"
export * from "./integral-report.vue?vue&type=script&lang=js&"
import style0 from "./integral-report.vue?vue&type=style&index=0&id=ca0f91de&prod&lang=scss&"
import style1 from "./integral-report.vue?vue&type=style&index=1&id=ca0f91de&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0f91de",
  null
  
)

export default component.exports